import {
    initialAlgorithmParametersRevisionIndexState,
    AlgorithmParametersRevisionIndexState,
} from './revisionIndex/AlgorithmParametersRevisionIndexState';

export default interface AlgorithmParametersSharedState {
    revisionIndex: AlgorithmParametersRevisionIndexState;
}

export const initialAlgorithmParametersSharedState: AlgorithmParametersSharedState =
    {
        revisionIndex: initialAlgorithmParametersRevisionIndexState,
    };
